// import WideProductCard from '@common/components/WideProductCard';
import ProductCardLoading from '@common/components/ProductCard/ProductCardLoading';
// import SmallProductCard from '@common/components/SmallProductCard';
import { RootState } from '@common/store';
import {
  addProductToCart,
  CartSliceType,
  removeProductFromCart,
  subtractProductFromCart,
} from '@common/store/cart/slice';
import {
  fetchProductsRequest,
  getProductQueryParamsInitialState,
  ProductsSliceType,
  resetProductsStore,
} from '@common/store/products/slice';
import { StoreInfoSliceType } from '@common/store/storeInfo/slice';
import { addToast } from '@common/store/toasts/slice';
import { smoothScroll } from '@common/utils';
import { PRODUCTS_KEY } from '@common/utils/constants';
import { ERROR_TEXT } from '@common/utils/errorContent';
import Pagination from '@components/Pagination';
import ProductCard from '@components/ProductCard';
import SectionHeading from '@components/SectionHeading';
import Error from '@lib/Error';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

interface HomeProps {
  products: Record<string, ProductsSliceType>;

  fetchProductsRequest: typeof fetchProductsRequest;
  resetProductsStore: typeof resetProductsStore;
  addProductToCart: typeof addProductToCart;
  subtractProductFromCart: typeof subtractProductFromCart;
  removeProductFromCart: typeof removeProductFromCart;
  addToast: typeof addToast;
  cart: CartSliceType;
  storeInfo: StoreInfoSliceType;
  title: string;
}

class Home extends PureComponent<HomeProps> {
  private allProductsRef: React.RefObject<HTMLDivElement>;
  constructor(props) {
    super(props);
    this.allProductsRef = React.createRef();
  }

  componentDidMount() {
    if (!this.props.products[PRODUCTS_KEY.ALL]?.list?.results.length) {
      this.props.resetProductsStore(PRODUCTS_KEY.ALL);
      this.props.fetchProductsRequest({
        storeKey: PRODUCTS_KEY.ALL,
        queryParams: {
          ...getProductQueryParamsInitialState(),
        },
      });
    }
  }

  render() {
    const mainProductsSlice = this.props.products[PRODUCTS_KEY.ALL];
    return (
      <div ref={this.allProductsRef} className="container layout-container mx-auto py-40">
        <div>
          <SectionHeading className={'mb-34 text-center'}>{this.props.title}</SectionHeading>
          {mainProductsSlice?.error ? <Error message={ERROR_TEXT.PRODUCTS} /> : null}
          <div className="flex flex-wrap items-stretch justify-center md:justify-between">
            {!this.props.products[PRODUCTS_KEY.ALL] ||
              (mainProductsSlice?.isFetching && (
                <>
                  <ProductCardLoading />
                  <ProductCardLoading />
                  <ProductCardLoading />
                  <ProductCardLoading />
                </>
              ))}
            {mainProductsSlice?.list?.results?.map((product) => (
              <>
                <div className="mb-50" key={product.id}>
                  <ProductCard
                    addToast={this.props.addToast}
                    product={product}
                    addProductToCart={this.props.addProductToCart}
                    subtractProductFromCart={this.props.subtractProductFromCart}
                    cartProductQuantity={this.props.cart.quantityByProductId[product.id] || 0}
                    cart={this.props.cart}
                    storeInfo={this.props.storeInfo}
                  />
                </div>
              </>
            ))}
            <ProductCard />
            <ProductCard />
          </div>
        </div>
        <Pagination
          className="mb-48 relative"
          {...mainProductsSlice?.pagination}
          onClick={(pageNumber) => {
            this.props.resetProductsStore(PRODUCTS_KEY.ALL);
            this.props.fetchProductsRequest({
              storeKey: PRODUCTS_KEY.ALL,
              queryParams: {
                ...mainProductsSlice?.currentQueryParams,
                page: pageNumber,
              },
            });
            smoothScroll(this.allProductsRef.current?.offsetTop - 150, 0);
          }}
        />
      </div>
    );
  }
}

export default connect(
  ({ products, storeInfo, cart }: RootState) => ({
    storeInfo,
    products,
    cart,
  }),
  {
    fetchProductsRequest,
    resetProductsStore,
  },
)(Home);
